var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderSadSmileicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6654 43.1668C42.6654 43.1668 38.6654 37.8335 31.9987 37.8335C25.332 37.8335 21.332 43.1668 21.332 43.1668M45.332 25.1402C44.2787 26.4335 42.8387 27.1668 41.332 27.1668C39.8254 27.1668 38.4254 26.4335 37.332 25.1402M26.6654 25.1402C25.612 26.4335 24.172 27.1668 22.6654 27.1668C21.1587 27.1668 19.7587 26.4335 18.6654 25.1402M58.6654 32.5002C58.6654 47.2278 46.7263 59.1668 31.9987 59.1668C17.2711 59.1668 5.33203 47.2278 5.33203 32.5002C5.33203 17.7726 17.2711 5.8335 31.9987 5.8335C46.7263 5.8335 58.6654 17.7726 58.6654 32.5002Z",
    stroke: "#9AACC7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderSadSmileicon);
export default __webpack_public_path__ + "static/media/placeholder--sad-smile.icon.3e8a2054f156ad18b18e7897360c941b.svg";
export { ForwardRef as ReactComponent };